import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { Entity, TypeParams } from './types'

@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context =>
      context ? gql.queries.adjustmentLabels.execute(context) : rxjs.of([]),
  )

  /** @inheritdoc */
  public create: ec.models.Api<TypeParams>['create'] = (context, entity) =>
    rxjs.of({
      id: entity.name,
      name: entity.name,
    })

  /** @inheritdoc */
  // FIXME: this should not be necessary. The entity collection library should
  // just update the cache when the update API method is not implemented
  public update: ec.models.Api<TypeParams>['update'] = (context, { updates }) =>
    // NOTE: The backend does not support direct creation or updating of
    // adjustment labels. However, on the frontend, they can be created or
    // updated in a "special" way. To ensure proper caching in the entity
    // collection, each update needs to be returned as it was saved to the
    // backend.
    // NOTE: Casting is used to align the argument and return types.
    rxjs.of(updates as Entity)
}
